var base = require('settings/subscription/resume-subscription');

Vue.component('spark-resume-subscription', {
    mixins: [base],

    data: function(){
        return {
            features_modal: false
        };
    },

    methods: {
        showPlanDetails : function(plan) {
            this.features_modal = plan.id;
            this.detailingPlan = plan;
        },
    }
});
